// extracted by mini-css-extract-plugin
export default {"bar":"StickyBar_bar__fYCmC","left":"StickyBar_left__eZZJc","price":"StickyBar_price__IyHaA","inst":"StickyBar_inst__aMSkg","btn":"StickyBar_btn__J3XfG"};